import { createColumnFactory } from '@/AgGridComponents/columnFactory';

export function buildTeamMemberInvoiceColumns(vm) {
    const col = createColumnFactory();
    return [
        col({
            headerName: '',
            checkboxSelection: true,
            headerComponent: 'PageHeaderCheckbox',
            minWidth: 50,
            maxWidth: 50,
            lockPosition: 'left',
            sortable: false,
            filter: false,
            suppressMenu: true,
            resizable: false
        }),
        col({
            headerName: 'Invoice Number',
            field: 'invoiceNumber',
            type: 'text',
            width: 160,
            cellRenderer: 'LinkRenderer',
            cellRendererParams: (params) =>
                vm.$_linkCellRenderer(
                    'Team Member Invoice Details',
                    { invoiceId: params.data.teamMemberInvoiceId },
                    params.value
                )
        }),
        col({
            headerName: 'Team Member',
            field: 'teamMemberName',
            type: 'boolean',
            cellRenderer: 'LinkRenderer',
            cellRendererParams: (params) =>
                vm.$_linkCellRenderer('Team Member Profile', { publicUserId: params.data.publicUserId }, params.value),
            keyCreator: (params) => (params.value ? params.value.fullName : ''),
            filterParams: {
                values: vm.loadTeamMembers,
                valueFormatter: (params) => (params.value ? params.value.fullName : ''),
                selectAllOnMiniFilter: true
            }
        }),
        col({
            headerName: 'Invoice Date',
            field: 'invoiceDate',
            type: 'date',
            valueFormatter: vm.$_dateFormatter,
            width: 140
        }),
        col({
            headerName: 'Due Date',
            field: 'dueDate',
            type: 'date',
            valueFormatter: vm.$_dateFormatter,
            width: 140
        }),
        col({
            headerName: 'SubTotal',
            field: 'subTotal',
            type: 'currency',
            valueFormatter: vm.$_currencyFormatter,
            width: 140
        }),
        col({
            headerName: 'Tax',
            field: 'totalTax',
            type: 'currency',
            valueFormatter: vm.$_currencyFormatter,
            width: 120
        }),
        col({
            headerName: 'Total Amount',
            field: 'total',
            type: 'currency',
            valueFormatter: vm.$_currencyFormatter,
            width: 160
        }),
        col({
            headerName: 'Status',
            field: 'status',
            type: 'boolean',
            width: 120,
            filterParams: {
                values: ['Draft', 'Paid', 'Unpaid', 'Approved', 'Rejected', 'OnHold'],
                selectAllOnMiniFilter: true
            }
        }),
        col({
            headerName: 'Company',
            field: 'company',
            type: 'boolean',
            hide: true,
            keyCreator: (params) => {
                if (params.value != null && params.value.name === '(Blank)') {
                    return null;
                }
                return params.value ? params.value.name : '';
            },
            filterParams: {
                values: vm.loadCompanies,
                valueFormatter: (params) => (params.value ? params.value.name : ''),
                selectAllOnMiniFilter: true
            }
        }),
        col({
            headerName: 'Team Region',
            field: 'teamRegionName',
            type: 'boolean',
            hide: true,
            keyCreator: (params) => {
                if (params.value != null && params.value.teamRegionId == null) {
                    return null;
                }
                return params.value ? params.value.name : '';
            },
            filterParams: {
                values: vm.loadTeamRegions,
                valueFormatter: (params) => (params.value ? params.value.name : ''),
                selectAllOnMiniFilter: true
            }
        }),
        col({
            headerName: 'Batch Date',
            field: 'teamMemberInvoiceBatchId',
            type: 'boolean',
            valueFormatter: (params) =>
                `${vm.$_formatDateFromUTC(params.data.invoiceBatchStartDate)} - ${vm.$_formatDateFromUTC(
                    params.data.invoiceBatchEndDate
                )}`,
            keyCreator: (params) => {
                if (params.value != null && params.value.teamMemberInvoiceBatchId == null) {
                    return null;
                }
                return params.value ? params.value.teamMemberInvoiceBatchId.toString() : '';
            },
            filterParams: {
                values: vm.loadBatchFilters,
                valueFormatter: (params) => (params.value ? params.value.name : ''),
                selectAllOnMiniFilter: true
            },
            hide: true
        }),
        col({
            headerName: 'Pro Rata Minimum',
            field: 'proRataAmount',
            type: 'currency',
            valueFormatter: vm.$_currencyFormatter,
            width: 160
        }),
        col({
            headerName: 'Minimum',
            field: 'weeklyMinimum',
            type: 'currency',
            valueFormatter: vm.$_currencyFormatter,
            width: 160
        }),
        col({
            headerName: 'Adjustments',
            field: 'totalAdjustments',
            type: 'currency',
            valueFormatter: vm.$_currencyFormatter,
            width: 140
        }),
        col({
            headerName: 'Make up',
            field: 'totalMinimumPay',
            type: 'currency',
            valueFormatter: vm.$_currencyFormatter,
            width: 140
        }),
        col({
            headerName: 'Total Trip Hours',
            field: 'totalTripHours',
            type: 'number',
            hide: true,
            width: 160,
            valueFormatter: (params) => {
                if (params.value == null) return '';
                return params.value.toFixed(2);
            }
        }),
        col({
            headerName: 'Total Trips',
            field: 'totalTrips',
            type: 'number',
            hide: true,
            width: 120
        }),
        col({
            headerName: 'Actions',
            cellRenderer: 'ActionRendererTeamMemberInvoice',
            cellRendererParams: (params) => vm.$_actionParameterCellRenderer(params, vm.refreshServerSide.bind(vm)),
            sortable: false,
            width: 250,
            pinned: 'right'
        })
    ];
}

export default buildTeamMemberInvoiceColumns;
